import { Box, Button, MenuItem, Stack } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import { useForm } from "react-hook-form";
import { OURA_STATE_STATUS } from "../../../utils/constants";
import RhfCheckBox from "../../form/RhfCheckBox";
import RhfTextField from "../../form/RhfTextField";

const emptySearchInputs = {
  macAddress: "",
  serialNumber: "",
  status: "",
  makeId: "",
  modelId: "",
  hubId: "",
  isBlocked: false,
  includeImage: true,
};

function DeviceSearchForm({ onSubmit, isSearchDisabled }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty },
  } = useForm({
    defaultValues: emptySearchInputs,
  });

  const resetForm = () => {
    reset();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack
        flexDirection="row"
        sx={{ display: { xs: "block", sm: "flex", width: "100%" } }}
      >
        <RhfTextField
          label="MAC Address"
          name="macAddress"
          control={control}
          sx={{
            mr: 2,
            mb: 2,
            backgroundColor: "#F1F1F1",
            borderRadius: 1,
            width: {
              xs: "100%",
              sm: "auto",
            },
          }}
          variant="outlined"
        />
        <RhfTextField
          label="Serial Number"
          name="serialNumber"
          control={control}
          sx={{
            mr: 2,
            mb: 2,
            backgroundColor: "#F1F1F1",
            borderRadius: 1,
            width: {
              xs: "100%",
              sm: "auto",
            },
          }}
          variant="outlined"
        />
        <RhfTextField
          label="Hub ID"
          name="hubId"
          control={control}
          sx={{
            mr: 2,
            mb: 2,
            backgroundColor: "#F1F1F1",
            borderRadius: 1,
            width: {
              xs: "100%",
              sm: "auto",
            },
          }}
          variant="outlined"
          inputProps={{ maxLength: 31 }}
        />
        <RhfTextField
          name="status"
          control={control}
          select
          label="Status"
          variant="outlined"
          sx={{
            mr: 2,
            mb: 2,
            backgroundColor: "#F1F1F1",
            borderRadius: 1,
            width: {
              xs: "100%",
              sm: 140,
            },
          }}
        >
          {Object.keys(OURA_STATE_STATUS).map((key) => {
            const status = OURA_STATE_STATUS[key];
            return (
              <MenuItem value={status.value} key={status.value}>
                {status.label}
              </MenuItem>
            );
          })}
        </RhfTextField>
        <Box
          sx={{
            display: { xs: "block", sm: "flex" },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <RhfCheckBox
            name="isBlocked"
            label="Blocked"
            control={control}
            sx={{ mr: 2, mb: 2 }}
          />
          <Box sx={{ display: "flex", width: "100%", gap: 1 }}>
            <Button
              sx={{
                mr: { xs: 0, sm: 2 },
                mb: 2,
                height: { xs: 50, sm: "auto" },
                width: { xs: "100%", sm: "auto" },
              }}
              color="primary"
              type="submit"
              variant="contained"
              disabled={isSearchDisabled}
            >
              Search
            </Button>
            <Button
              color="error"
              variant="contained"
              onClick={resetForm}
              disabled={!isDirty}
              sx={{
                mb: 2,
                height: { xs: 50, sm: "auto" },
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Clear
            </Button>
          </Box>
        </Box>
      </Stack>
    </form>
  );
}

DeviceSearchForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSearchDisabled: PropTypes.bool,
};

DeviceSearchForm.defaultProps = {
  isSearchDisabled: false,
};

export default DeviceSearchForm;
